import * as React from "react";
import { useInstantSearch } from "react-instantsearch";
import { clickedObjectIdsAfterSearch, clickedObjectIds } from "./AlgoliaAnalyticsHelpers.js";
import { AlgoliaAnalyticsEvents } from "./types.js";
import { useAlgoliaAnalytics } from "./useAlgoliaAnalytics.js";
const AlgoliaAnalytics = ({ children }) => {
  const {
    results: { queryID, index }
  } = useInstantSearch();
  const { saveData } = useAlgoliaAnalytics();
  const handleSearchAnalytics = React.useCallback(
    (objectId, position, eventName) => () => {
      const eventData = {
        eventName: eventName || AlgoliaAnalyticsEvents.SearchResultClicked,
        objectIds: objectId,
        searchIndex: index
      };
      if (queryID && position) {
        saveData({ queryId: queryID, searchIndex: index });
        clickedObjectIdsAfterSearch({
          ...eventData,
          queryId: queryID,
          positions: position
        });
      } else {
        clickedObjectIds(eventData);
      }
    },
    [index, queryID, saveData]
  );
  if (!children) {
    return null;
  }
  return children(handleSearchAnalytics);
};
export {
  AlgoliaAnalytics,
  AlgoliaAnalytics as default
};
//# sourceMappingURL=AlgoliaAnalytics.js.map
